// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contShowLayers{
    position: absolute;
    /* background-color: aliceblue; */
    height: auto;
    width: auto;
    z-index: 1;
    display: block;
    justify-content: left;
    align-items: center;
    top: 23%;
    padding-left: 3%;
}


.container-ShowLayers {
    position: relative;
    box-sizing: border-box;
    width: -moz-fit-content;
    width: fit-content;
    /* border-radius: var(--border-radios-small); */
  }
  .container-ShowLayers-list{
    /* background-color: #2c305cbd; */
    width: auto;
    height: auto;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    /* max-height: 150px; */
    max-height: 250px;
    overflow: auto;
  }
  
  .row-ShowLayers-list{
    /* background-color: #030915; */
   
position: relative;
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 30px;
/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */
/* color: #088eee; */
  }
  .cont-check-ShowLayers-list{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 100%;
  }
  #compact-ShowLayers-list {
    --background: #fff;
    --text: #414856;
    --check: #00aeff;
    --disabled: #c3c8de;
    --width: auto;
    --height: auto;
    --border-radius: 10px;
    /* background: var(--background); */
    width: var(--width);
    height: var(--height);
    border-radius: var(--border-radius);
    position: relative;
    box-shadow: 0 10px 30px rgba(65, 72, 86, 0.05);
    /* padding: 30px 85px; */
    display: grid;
    grid-template-columns: 30px auto;
    align-items: center;
    justify-content: center;
  }
  
  #compact-ShowLayers-list label {
    color: var(--txt-color-low);
    position: relative;
    cursor: pointer;
    display: grid;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 150px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.2;
    transition: color 0.3s ease;
    margin-right: 20px;
    margin-bottom: 10px;
    margin-left: 5px;
    font-size: var(--font-size-small);
  }
  
  #compact-ShowLayers-list label::before, #compact-ShowLayers-list label::after {
    /* content: "";
    position: absolute; */
  }
  
  #compact-ShowLayers-list label::before {
    height: 5px;
    width: 10px;
    left: -27px;
    background: var(--check);
    border-radius: 2px;
    transition: background 0.3s ease;
  }
  
  #compact-ShowLayers-list label:after {
    height: 4px;
    width: 4px;
    top: 8px;
    left: -25px;
    border-radius: 50%;
  }
  
  #compact-ShowLayers-list input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
    height: 15px;
    width: 15px;
    outline: none;
    border: 1px solid var(--txt-color-low);
    /* font-size: var(--font-size-medium); */
    margin: 0 15px 0 0;
    cursor: pointer;
    border-radius: 3px;
    /* background: var(--background); */
    display: grid;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
  margin-left: 5px;
  }
  
  #compact-ShowLayers-list input[type="checkbox"]::before, #compact-ShowLayers-list input[type="checkbox"]::after {
    content: "";
    position: absolute;
    height: 3px;
    top: auto;
    background: var(--check);
    border-radius: 2px;
    z-index: 2;
  }
  
  #compact-ShowLayers-list input[type="checkbox"]::before {
    width: 0px;
    right: 60%;
    transform-origin: right bottom;
  }
  
  #compact-ShowLayers-list input[type="checkbox"]::after {
    width: 0px;
    left: 40%;
    transform-origin: left bottom;
  }
  
  #compact-ShowLayers-list input[type="checkbox"]:checked::before {
    animation: check-01 0.4s ease forwards;
  }
  
  #compact-ShowLayers-list input[type="checkbox"]:checked::after {
    animation: check-02 0.4s ease forwards;
  }
  
  #compact-ShowLayers-list input[type="checkbox"]:checked + label {
    color: var(--txt-color);
    animation: move 0.3s ease 0.1s forwards;
    font-size: var(--font-size-small);
  }
  
  #compact-ShowLayers-list input[type="checkbox"]:checked + label::before {
    background: var(--disabled);
    animation: slice 0.4s ease forwards;
  }
  
  #compact-ShowLayers-list input[type="checkbox"]:checked + label::after {
    animation: firework 0.5s ease forwards 0.1s;
  }
  
  @keyframes move {
    50% {
      padding-left: 8px;
      padding-right: 0px;
    }
  
    100% {
      padding-right: 4px;
    }
  }
  
  @keyframes slice {
    60% {
      width: 100%;
      left: 4px;
    }
  
    100% {
      width: 100%;
      left: -2px;
      padding-left: 0;
    }
  }
  
  @keyframes check-01 {
    0% {
      width: 4px;
      top: auto;
      transform: rotate(0);
    }
  
    50% {
      width: 0px;
      top: auto;
      transform: rotate(0);
    }
  
    51% {
      width: 0px;
      top: 8px;
      transform: rotate(45deg);
    }
  
    100% {
      width: 5px;
      top: 8px;
      transform: rotate(45deg);
    }
  }
  
  @keyframes check-02 {
    0% {
      width: 4px;
      top: auto;
      transform: rotate(0);
    }
  
    50% {
      width: 0px;
      top: auto;
      transform: rotate(0);
    }
  
    51% {
      width: 0px;
      top: 8px;
      transform: rotate(-45deg);
    }
  
    100% {
      width: 10px;
      top: 8px;
      transform: rotate(-45deg);
    }
  }
  
  @keyframes firework {
    0% {
      opacity: 1;
      box-shadow: 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0;
    }
  
    30% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
      box-shadow: 0 -15px 0 0px #4f29f0, 14px -8px 0 0px #4f29f0, 14px 8px 0 0px #4f29f0, 0 15px 0 0px #4f29f0, -14px 8px 0 0px #4f29f0, -14px -8px 0 0px #4f29f0;
    }
  }
  .cont-text-ShowLayers-list{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70%;
    height: 100%;
    color: aliceblue;
  }
  /* .row-ShowLayers-list:hover{
    background-color: aliceblue;
    cursor: pointer;
  } */
  .mainbox-ShowLayers {
    box-sizing: border-box;
    position: relative;
    width: auto;
    height: auto;
    display: block;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    border-radius: var(--border-radios-small);
    background-color: var(--white-color);
    /* background-color: #404040e5; */
    transition: all 0.3s ease;
    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);
  border: 1px solid var(--main-color) 
  }
  .txtTitle--ShowLayers{
    position: relative;
    width: 100%;
    height: 15%;
    top: 0%;
    color: var(--main-color);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #c8c8c83b;
    font-size: var(--font-size-med);
  }
  .checkbox-ShowLayers:focus {
    border: none;
    outline: none;
  }
  
  .checkbox-ShowLayers:checked {
    /* right: 10px; */
    height: 100%;
  }
  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers .txtTitle--ShowLayers {
    border-bottom: unset;
    height: 100%;
  }
  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers .container-ShowLayers-list {
    display: none;
  }
  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers {
    width: 80px;
    height: 30px;
    border-radius: 160px;
  }
  .checkbox-ShowLayers:checked ~ .container-ShowLayers-list {
    display: none;
  }
  
  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers .search_input-ShowLayers {
    width: 0;
    height: 0px;
  }
  
  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers .iconcontainer-ShowLayers {
    padding-right: 8px;
  }
  
  .checkbox-ShowLayers {
    box-sizing: border-box;
    width: 100%;
    height: 15%;
    position: absolute;
    /* right: 17px; */
    /* top: 10px; */
    z-index: 9;
    cursor: pointer;
    appearance: none;
  }
  
  .search_input-ShowLayers {
    box-sizing: border-box;
    height: 100%;
    width: 170px;
    background-color: transparent;
    border: none;
    outline: none;
    padding-bottom: 4px;
    padding-left: 10px;
    font-size: 1em;
    color: white;
    transition: all 0.3s ease;
    font-family: "Roboto" !important
  }
  
  .search_input-ShowLayers::placeholder {
    color: rgba(255, 255, 255, 0.776);
  }
  
  .iconcontainer-ShowLayers {
    box-sizing: border-box;
    padding-top: 5px;
    width: -moz-fit-content;
    width: fit-content;
    transition: all 0.3s ease;
  }
  
  .search_icon-ShowLayers {
    box-sizing: border-box;
    fill: white;
    font-size: 1.3em;
  }


  .cont-findHost {
    width: 120px;
  height: 15px;
  position: relative;
  background-color: rgb(252, 255, 153);
  color: #34373c;
  font-size: small;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  }
  .row-close-list{
    color: red;
  }`, "",{"version":3,"sources":["webpack://./src/components/styles/ShowLayers.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,WAAW;IACX,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAkB;IAAlB,kBAAkB;IAClB,+CAA+C;EACjD;EACA;IACE,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,+BAA+B;;AAEnC,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,0DAA0D;AAC1D,oBAAoB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,mCAAmC;IACnC,mBAAmB;IACnB,qBAAqB;IACrB,mCAAmC;IACnC,kBAAkB;IAClB,8CAA8C;IAC9C,wBAAwB;IACxB,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE;yBACqB;EACvB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,UAAU;IACV,QAAQ;IACR,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sCAAsC;IACtC,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB,gBAAgB;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;IACV,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,SAAS;IACT,6BAA6B;EAC/B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;IACvB,uCAAuC;IACvC,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,mCAAmC;EACrC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,WAAW;MACX,SAAS;IACX;;IAEA;MACE,WAAW;MACX,UAAU;MACV,eAAe;IACjB;EACF;;EAEA;IACE;MACE,UAAU;MACV,SAAS;MACT,oBAAoB;IACtB;;IAEA;MACE,UAAU;MACV,SAAS;MACT,oBAAoB;IACtB;;IAEA;MACE,UAAU;MACV,QAAQ;MACR,wBAAwB;IAC1B;;IAEA;MACE,UAAU;MACV,QAAQ;MACR,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;MACV,SAAS;MACT,oBAAoB;IACtB;;IAEA;MACE,UAAU;MACV,SAAS;MACT,oBAAoB;IACtB;;IAEA;MACE,UAAU;MACV,QAAQ;MACR,yBAAyB;IAC3B;;IAEA;MACE,WAAW;MACX,QAAQ;MACR,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,UAAU;MACV,kIAAkI;IACpI;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;MACV,2JAA2J;IAC7J;EACF;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;EACA;;;KAGG;EACH;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;IACzC,oCAAoC;IACpC,iCAAiC;IACjC,yBAAyB;IACzB,8CAA8C;EAChD;EACA;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,OAAO;IACP,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;IAClC,+BAA+B;EACjC;EACA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB;EACF;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;;EAGA;IACE,YAAY;EACd,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB;EACA;IACE,UAAU;EACZ","sourcesContent":[".contShowLayers{\r\n    position: absolute;\r\n    /* background-color: aliceblue; */\r\n    height: auto;\r\n    width: auto;\r\n    z-index: 1;\r\n    display: block;\r\n    justify-content: left;\r\n    align-items: center;\r\n    top: 23%;\r\n    padding-left: 3%;\r\n}\r\n\r\n\r\n.container-ShowLayers {\r\n    position: relative;\r\n    box-sizing: border-box;\r\n    width: fit-content;\r\n    /* border-radius: var(--border-radios-small); */\r\n  }\r\n  .container-ShowLayers-list{\r\n    /* background-color: #2c305cbd; */\r\n    width: auto;\r\n    height: auto;\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    /* max-height: 150px; */\r\n    max-height: 250px;\r\n    overflow: auto;\r\n  }\r\n  \r\n  .row-ShowLayers-list{\r\n    /* background-color: #030915; */\r\n   \r\nposition: relative;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nwidth: 100%;\r\nheight: 30px;\r\n/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */\r\n/* color: #088eee; */\r\n  }\r\n  .cont-check-ShowLayers-list{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 30%;\r\n    height: 100%;\r\n  }\r\n  #compact-ShowLayers-list {\r\n    --background: #fff;\r\n    --text: #414856;\r\n    --check: #00aeff;\r\n    --disabled: #c3c8de;\r\n    --width: auto;\r\n    --height: auto;\r\n    --border-radius: 10px;\r\n    /* background: var(--background); */\r\n    width: var(--width);\r\n    height: var(--height);\r\n    border-radius: var(--border-radius);\r\n    position: relative;\r\n    box-shadow: 0 10px 30px rgba(65, 72, 86, 0.05);\r\n    /* padding: 30px 85px; */\r\n    display: grid;\r\n    grid-template-columns: 30px auto;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  #compact-ShowLayers-list label {\r\n    color: var(--txt-color-low);\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: grid;\r\n    align-items: center;\r\n    width: fit-content;\r\n    max-width: 150px;\r\n    white-space: normal;\r\n    word-break: break-word;\r\n    line-height: 1.2;\r\n    transition: color 0.3s ease;\r\n    margin-right: 20px;\r\n    margin-bottom: 10px;\r\n    margin-left: 5px;\r\n    font-size: var(--font-size-small);\r\n  }\r\n  \r\n  #compact-ShowLayers-list label::before, #compact-ShowLayers-list label::after {\r\n    /* content: \"\";\r\n    position: absolute; */\r\n  }\r\n  \r\n  #compact-ShowLayers-list label::before {\r\n    height: 5px;\r\n    width: 10px;\r\n    left: -27px;\r\n    background: var(--check);\r\n    border-radius: 2px;\r\n    transition: background 0.3s ease;\r\n  }\r\n  \r\n  #compact-ShowLayers-list label:after {\r\n    height: 4px;\r\n    width: 4px;\r\n    top: 8px;\r\n    left: -25px;\r\n    border-radius: 50%;\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"] {\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    position: relative;\r\n    height: 15px;\r\n    width: 15px;\r\n    outline: none;\r\n    border: 1px solid var(--txt-color-low);\r\n    /* font-size: var(--font-size-medium); */\r\n    margin: 0 15px 0 0;\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n    /* background: var(--background); */\r\n    display: grid;\r\n    align-items: center;\r\n    margin-right: 20px;\r\n    margin-bottom: 10px;\r\n  margin-left: 5px;\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"]::before, #compact-ShowLayers-list input[type=\"checkbox\"]::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    height: 3px;\r\n    top: auto;\r\n    background: var(--check);\r\n    border-radius: 2px;\r\n    z-index: 2;\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"]::before {\r\n    width: 0px;\r\n    right: 60%;\r\n    transform-origin: right bottom;\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"]::after {\r\n    width: 0px;\r\n    left: 40%;\r\n    transform-origin: left bottom;\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"]:checked::before {\r\n    animation: check-01 0.4s ease forwards;\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"]:checked::after {\r\n    animation: check-02 0.4s ease forwards;\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"]:checked + label {\r\n    color: var(--txt-color);\r\n    animation: move 0.3s ease 0.1s forwards;\r\n    font-size: var(--font-size-small);\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"]:checked + label::before {\r\n    background: var(--disabled);\r\n    animation: slice 0.4s ease forwards;\r\n  }\r\n  \r\n  #compact-ShowLayers-list input[type=\"checkbox\"]:checked + label::after {\r\n    animation: firework 0.5s ease forwards 0.1s;\r\n  }\r\n  \r\n  @keyframes move {\r\n    50% {\r\n      padding-left: 8px;\r\n      padding-right: 0px;\r\n    }\r\n  \r\n    100% {\r\n      padding-right: 4px;\r\n    }\r\n  }\r\n  \r\n  @keyframes slice {\r\n    60% {\r\n      width: 100%;\r\n      left: 4px;\r\n    }\r\n  \r\n    100% {\r\n      width: 100%;\r\n      left: -2px;\r\n      padding-left: 0;\r\n    }\r\n  }\r\n  \r\n  @keyframes check-01 {\r\n    0% {\r\n      width: 4px;\r\n      top: auto;\r\n      transform: rotate(0);\r\n    }\r\n  \r\n    50% {\r\n      width: 0px;\r\n      top: auto;\r\n      transform: rotate(0);\r\n    }\r\n  \r\n    51% {\r\n      width: 0px;\r\n      top: 8px;\r\n      transform: rotate(45deg);\r\n    }\r\n  \r\n    100% {\r\n      width: 5px;\r\n      top: 8px;\r\n      transform: rotate(45deg);\r\n    }\r\n  }\r\n  \r\n  @keyframes check-02 {\r\n    0% {\r\n      width: 4px;\r\n      top: auto;\r\n      transform: rotate(0);\r\n    }\r\n  \r\n    50% {\r\n      width: 0px;\r\n      top: auto;\r\n      transform: rotate(0);\r\n    }\r\n  \r\n    51% {\r\n      width: 0px;\r\n      top: 8px;\r\n      transform: rotate(-45deg);\r\n    }\r\n  \r\n    100% {\r\n      width: 10px;\r\n      top: 8px;\r\n      transform: rotate(-45deg);\r\n    }\r\n  }\r\n  \r\n  @keyframes firework {\r\n    0% {\r\n      opacity: 1;\r\n      box-shadow: 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0, 0 0 0 -2px #4f29f0;\r\n    }\r\n  \r\n    30% {\r\n      opacity: 1;\r\n    }\r\n  \r\n    100% {\r\n      opacity: 0;\r\n      box-shadow: 0 -15px 0 0px #4f29f0, 14px -8px 0 0px #4f29f0, 14px 8px 0 0px #4f29f0, 0 15px 0 0px #4f29f0, -14px 8px 0 0px #4f29f0, -14px -8px 0 0px #4f29f0;\r\n    }\r\n  }\r\n  .cont-text-ShowLayers-list{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 70%;\r\n    height: 100%;\r\n    color: aliceblue;\r\n  }\r\n  /* .row-ShowLayers-list:hover{\r\n    background-color: aliceblue;\r\n    cursor: pointer;\r\n  } */\r\n  .mainbox-ShowLayers {\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    width: auto;\r\n    height: auto;\r\n    display: block;\r\n    flex-direction: row-reverse;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: var(--border-radios-small);\r\n    background-color: var(--white-color);\r\n    /* background-color: #404040e5; */\r\n    transition: all 0.3s ease;\r\n    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);\r\n  border: 1px solid var(--main-color) \r\n  }\r\n  .txtTitle--ShowLayers{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 15%;\r\n    top: 0%;\r\n    color: var(--main-color);\r\n    text-align: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-bottom: 1px solid #c8c8c83b;\r\n    font-size: var(--font-size-med);\r\n  }\r\n  .checkbox-ShowLayers:focus {\r\n    border: none;\r\n    outline: none;\r\n  }\r\n  \r\n  .checkbox-ShowLayers:checked {\r\n    /* right: 10px; */\r\n    height: 100%;\r\n  }\r\n  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers .txtTitle--ShowLayers {\r\n    border-bottom: unset;\r\n    height: 100%;\r\n  }\r\n  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers .container-ShowLayers-list {\r\n    display: none;\r\n  }\r\n  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers {\r\n    width: 80px;\r\n    height: 30px;\r\n    border-radius: 160px;\r\n  }\r\n  .checkbox-ShowLayers:checked ~ .container-ShowLayers-list {\r\n    display: none;\r\n  }\r\n  \r\n  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers .search_input-ShowLayers {\r\n    width: 0;\r\n    height: 0px;\r\n  }\r\n  \r\n  .checkbox-ShowLayers:checked ~ .mainbox-ShowLayers .iconcontainer-ShowLayers {\r\n    padding-right: 8px;\r\n  }\r\n  \r\n  .checkbox-ShowLayers {\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n    height: 15%;\r\n    position: absolute;\r\n    /* right: 17px; */\r\n    /* top: 10px; */\r\n    z-index: 9;\r\n    cursor: pointer;\r\n    appearance: none;\r\n  }\r\n  \r\n  .search_input-ShowLayers {\r\n    box-sizing: border-box;\r\n    height: 100%;\r\n    width: 170px;\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    padding-bottom: 4px;\r\n    padding-left: 10px;\r\n    font-size: 1em;\r\n    color: white;\r\n    transition: all 0.3s ease;\r\n    font-family: \"Roboto\" !important\r\n  }\r\n  \r\n  .search_input-ShowLayers::placeholder {\r\n    color: rgba(255, 255, 255, 0.776);\r\n  }\r\n  \r\n  .iconcontainer-ShowLayers {\r\n    box-sizing: border-box;\r\n    padding-top: 5px;\r\n    width: fit-content;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .search_icon-ShowLayers {\r\n    box-sizing: border-box;\r\n    fill: white;\r\n    font-size: 1.3em;\r\n  }\r\n\r\n\r\n  .cont-findHost {\r\n    width: 120px;\r\n  height: 15px;\r\n  position: relative;\r\n  background-color: rgb(252, 255, 153);\r\n  color: #34373c;\r\n  font-size: small;\r\n  border-radius: 100px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: bold;\r\n  }\r\n  .row-close-list{\r\n    color: red;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
